function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#202124",
  fillRule: "nonzero",
  stroke: "#202124",
  strokeWidth: 1.2
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.349 5.333C1.058 5.333 0 6.391 0 7.682v16.734c0 1.128.927 2.055 2.055 2.055h19.963c1.129 0 2.055-.927 2.055-2.055V10.91c0-1.128-.926-2.055-2.055-2.055H20.55V5.92c0-.307-.28-.587-.587-.587H2.35zm0 1.175h17.027v2.348H2.35c-.661 0-1.175-.513-1.175-1.174 0-.66.514-1.174 1.175-1.174zM1.174 9.709c.346.202.748.322 1.175.322 6.612-.006 13.986 0 19.67 0 .497 0 .88.382.88.88V24.416c0 .498-.383.88-.88.88H2.054c-.498 0-.88-.382-.88-.88V9.709z",
  transform: "translate(-409 -286) translate(385 270) translate(24 16)"
})))));

var SvgIconWallet = function SvgIconWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-wallet.c0d75105.svg";
export { ForwardRef as ReactComponent };